export default __webpack_public_path__ + "static/media/txt.0ceae6d4.png";